import { DragOverlay } from "@dnd-kit/core";
import { forwardRef, useImperativeHandle, useState } from "react";
import EventEditCard from "./views/EventEditCard";

const EventDragOverlay = forwardRef((props, ref) => {
  // State to hold the currently active (dragged) event
  const [activeEvent, setActiveEvent] = useState(null);

  // Expose setActiveEvent method to parent component via ref
  useImperativeHandle(ref, () => ({
    setActiveEvent,
  }));

  return (
    <DragOverlay zIndex={9999}>
      {activeEvent ? (
        <EventEditCard
          item={activeEvent}
          isSelected={false}
          sx={{
            cursor: "grabbing",
            opacity: 0.9,
          }}
        />
      ) : null}
    </DragOverlay>
  );
});

export default EventDragOverlay;
